var location = function(options){

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

location.prototype.init = function(){

	var self = this;

};

module.exports = location;
